import { render, staticRenderFns } from "./rulesetting.vue?vue&type=template&id=b315f03c&scoped=true&"
import script from "./rulesetting.vue?vue&type=script&lang=js&"
export * from "./rulesetting.vue?vue&type=script&lang=js&"
import style0 from "./rulesetting.vue?vue&type=style&index=0&id=b315f03c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b315f03c",
  null
  
)

export default component.exports